import React, { useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { CarModel } from 'models/StockModel';
import auth from 'recoil/atoms/auth';
import Api from 'utils/api';
import { replaceItemAtIndex } from 'utils/common';


const appId = process.env.REACT_APP_API_UUID;

const useSyncCars = (setCars: React.Dispatch<React.SetStateAction<CarModel[]>>) => {
    const my = useRecoilValue(auth);

    useEffect(() => {
        const callback = (e: { cars: number[] }) => {
            Api.cars.getMultiple(e.cars).then(res => setCars(old => {
                let temp = [...old];

                res.data.forEach((car: CarModel) => {
                    temp = replaceItemAtIndex(temp, temp.findIndex(i => i.id === car.id), car)
                });

                return temp;
            }))
        };

        window.Echo.private(`${appId}.company.${my.company.id}`)
            .listen('CarsUpdated', callback)

        return () => {
            window.Echo.private(`${appId}.company.${my.company.id}`)
                .stopListening('CarsUpdated', callback)
        }
        // eslint-disable-next-line
    }, []);
};

export default useSyncCars;
